"use client";

import React, { createContext, useContext, useReducer, ReactNode } from "react";
interface State {
  progressPercentage: number;
}
interface Action {
  type: "SET_PROGRESS";
  payload: number;
}
const initialState: State = {
  progressPercentage: 0
};
const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "SET_PROGRESS":
      return {
        ...state,
        progressPercentage: action.payload
      };
    default:
      return state;
  }
};
interface FormProgressBarProviderProps {
  children: ReactNode;
}
const FormProgressBarContext = createContext<{
  state: State;
  dispatch: React.Dispatch<Action>;
}>({
  state: initialState,
  dispatch: () => null
});
export const FormProgressBarProvider: React.FC<FormProgressBarProviderProps> = ({
  children
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return <FormProgressBarContext.Provider value={{
    state,
    dispatch
  }} data-sentry-element="unknown" data-sentry-component="FormProgressBarProvider" data-sentry-source-file="FormProgressBarContext.tsx">
      {children}
    </FormProgressBarContext.Provider>;
};
export const useFormProgressBar = () => useContext(FormProgressBarContext);